import { FC } from "react";

import { Box, Stack, SxProps, Theme } from "@mui/material";
import { AvailablePaymentCurrency, Locales } from "@simplyk/common";

import { cartDeleteIconSx, CartRow, formatPrice } from "../helper";

import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Delete } from "@/icons/outlined";

interface CartTicketRowProps {
  row: CartRow;
  formCurrency: AvailablePaymentCurrency;
  locale: Locales;
  removeLabel: string;
  onDelete: () => void;
}

export const CartTicketRow: FC<CartTicketRowProps> = ({ row, formCurrency, locale, removeLabel, onDelete }) => {
  const titleLine = row.variantLabel ? `${row.title} • ${row.variantLabel}` : row.title;

  return (
    <Stack gap={0.5}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={1}>
        <FormTypography variant="body2" vibe="moderate">
          {titleLine}
        </FormTypography>
        <Stack direction="row" alignItems="center" gap={1} flexShrink={0}>
          <FormTypography variant="body2" vibe="moderate">
            {formatPrice(row.unitPrice, formCurrency, locale)}
          </FormTypography>
          <FormIcon size="small" aria-label={removeLabel} onClick={onDelete} sx={cartDeleteIconSx}>
            <Delete />
          </FormIcon>
        </Stack>
      </Stack>
      {row.answers.length > 0 && (
        <Box component="ul" sx={cartAnswersListSx}>
          {row.answers.map((answer, idx) => (
            <Box component="li" key={idx} sx={cartAnswersItemSx}>
              <FormTypography variant="body2" vibe="moderate">
                {answer}
              </FormTypography>
            </Box>
          ))}
        </Box>
      )}
    </Stack>
  );
};

const cartAnswersListSx: SxProps<Theme> = {
  listStyle: "disc",
  paddingInlineStart: "21px",
  margin: 0,
};

const cartAnswersItemSx: SxProps<Theme> = {
  display: "list-item",
};
